import { useEffect, useCallback, useRef } from 'react'

export function useEventListener(type: string, listener: () => void) {
  const listenerRef = useRef(listener)
  useEffect(() => {
    listenerRef.current = listener
  })

  useEffect(() => {
    const listener = listenerRef.current
    window.addEventListener(type, listener)
    return () => {
      window.removeEventListener(type, listener)
    }
  }, [type])
}

export function useDispatchEvent(eventName: string, detail?: any) {
  const dispatchEvent = useCallback(() => {
    if (detail) {
      window.dispatchEvent(new CustomEvent(eventName, { detail }))
    } else {
      window.dispatchEvent(new Event(eventName))
    }
  }, [eventName, detail])

  return dispatchEvent
}
